import { EmptyState, buttonClass, useDocumentTitle } from "@unizpay/ui";
import { Link } from "react-router";

export function NotFoundPage() {
  useDocumentTitle("Not found");
  return (
    <EmptyState
      title="Page not found"
      action={
        <Link to="/" className={buttonClass("secondary")}>
          Back to relayers
        </Link>
      }
    >
      There is nothing at this address.
    </EmptyState>
  );
}
